import { render, staticRenderFns } from "./CityInput.vue?vue&type=template&id=5765a20b&"
import script from "./CityInput.vue?vue&type=script&lang=js&"
export * from "./CityInput.vue?vue&type=script&lang=js&"
import style0 from "./CityInput.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/modules/shared/ui/public/forms/fields/CityInput.vue
// module id = 1136
// module chunks = 0